module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab"
  }, [_c('div', {
    staticClass: "tab-head"
  }, _vm._l((_vm.tabs), function(tab) {
    return _c('div', {
      staticClass: "tab-headItem",
      class: {
        'tab-headItem--active': tab.isActive
      },
      on: {
        "click": function($event) {
          _vm.select(tab)
        }
      }
    }, [_vm._v("\r\n      " + _vm._s(tab.name) + "\r\n    ")])
  })), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-00e69ac2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tabs.vue
// module id = 62
// module chunks = 0